<div class="muckpile-state-content">
    <table *ngIf="details?.muckpile_statistics as stats">
        <caption class="mt-1 text-underline font-bold">Muckpile Statistics</caption>
        <tr>
            <td>Area</td>
            <td class="text-right">{{ stats.area }} {{ areaUnit }}</td>
        </tr>
    </table>

    <table *ngIf="details?.rocks_statistics as stats">
        <caption class="mt-1 text-underline font-bold">Rock Statistics</caption>
        <tr>
            <td>Rocks Count</td>
            <td class="text-right">{{ stats.rocks_count }}</td>
        </tr>
        <tr>
            <td>Empty Aspect Ratio</td>
            <td class="text-right">{{ stats.empty_aspect_ratio }}</td>
        </tr>
        <tr>
            <td>Std Deviation Diameter</td>
            <td class="text-right">{{ stats.std_rocks_diameter }} {{ particleSizeUnit }}</td>
        </tr>
        <tr>
            <td>Mean Rock Diameter</td>
            <td class="text-right">{{ stats.mean_rocks_diameter }} {{ particleSizeUnit }}</td>
        </tr>
        <tr>
            <td>Max Rock Diameter</td>
            <td class="text-right">{{ stats.maximum_rocks_diameter }} {{ particleSizeUnit }}</td>
        </tr>
        <tr>
            <td>Min Rock Diameter</td>
            <td class="text-right">{{ stats.minimum_rocks_diameter }} {{ particleSizeUnit }}</td>
        </tr>
    </table>
</div>